import type { ApiKeys } from '../types';
const KEY = 'aurora-api-keys';
export function loadKeys(): ApiKeys {
  const raw = sessionStorage.getItem(KEY) ?? localStorage.getItem(KEY);
  if (!raw) return { groq: '', gemini: '', remember: false };
  try { const value = JSON.parse(raw) as Partial<ApiKeys>; return { groq: value.groq ?? '', gemini: value.gemini ?? '', remember: Boolean(localStorage.getItem(KEY)) }; }
  catch { return { groq: '', gemini: '', remember: false }; }
}
export function saveKeys(keys: ApiKeys): void {
  const value = JSON.stringify({ groq: keys.groq, gemini: keys.gemini });
  sessionStorage.setItem(KEY, value);
  if (keys.remember) localStorage.setItem(KEY, value); else localStorage.removeItem(KEY);
}
